import { Anchor, Box, Breadcrumbs, Text } from '@mantine/core';
import { IconChevronLeft } from '@tabler/icons-react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const NAVY = '#415A91';

/**
 * Wraps every page under /settings with a trail back to the settings index.
 *
 * Without it a settings sub-page is a dead end — the sidebar's Settings entry
 * is the only way back, and it is not obvious that the page you are on sits
 * beneath it.
 *
 * Sub-pages are listed here rather than each page rendering its own trail, so
 * adding a settings section is one entry in this map and nothing else.
 */
const SECTION_LABELS: Record<string, string> = {
  members: 'Members',
};

export function SettingsLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const segment = location.pathname.replace(/^\/settings\/?/, '').split('/')[0];
  // The index page's own heading already says "Settings"; a one-item trail
  // above it would just repeat itself.
  const label = segment ? (SECTION_LABELS[segment] ?? 'Settings') : null;

  return (
    <Box>
      {label && (
        <Box pt="lg" px={32}>
          <Breadcrumbs
            separator="›"
            styles={{ separator: { color: '#8E99AB' } }}
          >
            <Anchor
              onClick={() => navigate('/settings')}
              c={NAVY}
              fw={500}
              size="sm"
              style={{ display: 'flex', alignItems: 'center', gap: 2 }}
            >
              <IconChevronLeft size={14} />
              Settings
            </Anchor>
            <Text size="sm" c="#6B7685">
              {label}
            </Text>
          </Breadcrumbs>
        </Box>
      )}

      <Outlet />
    </Box>
  );
}
